function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip_chevron_down)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 5.13a.75.75 0 011.293-.517L10 13.78l8.706-9.165a.751.751 0 011.088 1.034l-9.25 9.738a.75.75 0 01-1.088 0L.205 5.648A.753.753 0 010 5.13z",
  fill: "#00253E"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip_chevron_down"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0V0z",
  fill: "#fff"
})))));